import { type ContextType, useContext } from 'react';

import { AgreementAndApprovalsContext } from './agreement-and-approvals-context';

export const useAgreementAndApprovalsContext = (): NonNullable<
  ContextType<typeof AgreementAndApprovalsContext>
> => {
  const context = useContext(AgreementAndApprovalsContext);
  if (!context) {
    throw new Error(
      'useAgreementAndApprovalsContext must be used within a AgreementAndApprovalsProvider',
    );
  }

  return context;
};
